import Vue from 'vue'
import VueRouter from 'vue-router'
import zfbMiddlePage from '@/views/result/zfbMiddlePage.vue'
import newCloudPhone from '@/views/buy/newCloudPhone.vue'
import renewCloudPhone from '@/views/buy/renewCloudPhone.vue'

Vue.use(VueRouter)

const Buy = [
    {
        path: '/zfbMiddlePage',
        name: 'ZfbMiddlePage',
        component: zfbMiddlePage
    },
    {
        path: '/newCloudPhone',
        name: 'NewCloudPhone',
        component: newCloudPhone
    },
    {
        path: '/renewCloudPhone',
        name: 'RenewCloudPhone',
        component: renewCloudPhone
    },
]

export default Buy
